import { memo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import ContactAdvisorEmailForm from '../ContactAdvisorEmailForm';

const ContactAdvisorEmailModal = ({ isModalOpen, handleCloseModal }) => (
  <Modal
    open={isModalOpen}
    onClose={handleCloseModal}
  >
    <div className="p-8">
      <div className="text-theme font-bold sm:text-sm xl:text-lg">
        Contact Travel Advisor
      </div>
      <ContactAdvisorEmailForm />
    </div>
  </Modal>
);

ContactAdvisorEmailModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

export default memo(ContactAdvisorEmailModal);
